/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Users_Enabled_For_All_UsersInputs */

const en_tables_users_enabled_for_all_users = /** @type {(inputs: Tables_Users_Enabled_For_All_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled For All Users`)
};

const de_tables_users_enabled_for_all_users = /** @type {(inputs: Tables_Users_Enabled_For_All_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktiviert für alle Benutzer`)
};

/**
* | output |
* | --- |
* | "Enabled For All Users" |
*
* @param {Tables_Users_Enabled_For_All_UsersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_users_enabled_for_all_users = /** @type {((inputs?: Tables_Users_Enabled_For_All_UsersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Users_Enabled_For_All_UsersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_users_enabled_for_all_users(inputs)
	return de_tables_users_enabled_for_all_users(inputs)
});